export const getSolutionName = (menuName, pathname) => {
  // Menu name mapping
  const menuMapping = {
    MAIL_LINK: 'MAIL',
    BOARD_LINK: 'BOARD',
    SMS_LINK: 'SMS',
    BILL_LINK: 'BILL',
    SCHEDULE_LINK: 'SCHEDULE',
    SHARED_LINK: 'SHARED',
    ADDR_LINK: 'ADDR',
    BOOKING_LINK: 'BOOKING',
    ORG_LINK: 'ORG',
    ORG_ADMIN_LINK: 'ORG_ADMIN',
    STORE_LINK: 'STORE',
    GROUP_LINK: 'GROUP',
    ADMIN_LINK: 'ADMIN',
    ACCOUNTING_LINK: 'ACCOUNTING',
    PAYZON_LINK: 'PAYZON',
    NOTES_LINK: 'NOTES',
    쪽지: 'NOTES',
    FILES_LINK: 'FILES',
    'AI 채팅': 'AI',
    AI채팅: 'AI',
    AI: 'AI',
    PLUS_LINK: 'PLUS',
    업무관리: 'TASKS',
    APPROVAL_LINK: 'APPROVAL',
    OFFICE_HOME: 'OFFICE_HOME',
  };

  // Path patterns mapping
  const pathPatterns = [
    { pattern: ['/mail/', '/officemail/'], solution: 'MAIL' },
    { pattern: ['/board/', '/bbs/'], solution: 'BOARD' },
    { pattern: ['/ea/', '/approval/'], solution: 'APPROVAL' },
    { pattern: ['/org/', '/insa/'], solution: 'ORG' },
    { pattern: ['/sms/'], solution: 'SMS' },
    { pattern: ['/webhard/'], solution: 'WEBHARD' },
    { pattern: ['/addr'], solution: 'ADDR' },
    { pattern: ['/shared/'], solution: 'SHARED' },
    { pattern: ['/bill'], solution: 'BILL' },
    { pattern: ['/schedule'], solution: 'SCHEDULE' },
    { pattern: ['/booking/'], solution: 'BOOKING' },
    { pattern: ['/store'], solution: 'STORE' },
    { pattern: ['/common/security', '/h_admin/', '/common/security/', '/point/'], solution: 'ADMIN' },
    { pattern: ['/accounting/'], solution: 'ACCOUNTING' },
    { pattern: ['/group/'], solution: 'GROUP' },
    { pattern: ['/common/office_main'], solution: 'OFFICE_HOME' },
    { pattern: ['/point/'], solution: 'POINT_MANAGE' },
    { pattern: ['/partner/payzon/'], solution: 'PAYZON' },
    { pattern: ['/apps/'], solution: 'API_MANAGE' },
    { pattern: ['/mypage/manager/'], solution: 'SETTING' },
    { pattern: ['/mypage/manager/my_info'], solution: 'SETTING' },
  ];

  // Check menu name first
  if (menuName in menuMapping) {
    return menuMapping[menuName];
  }

  // Check pathname patterns
  for (const { pattern, solution } of pathPatterns) {
    if (pattern.some((p) => pathname.includes(p))) {
      return solution;
    }
  }

  return '';
};
